import { relations } from 'drizzle-orm'
import { date, integer, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
} from '../common/utils'
import { maintenanceTasks, maintenanceTaskSteps } from './maintenanceTask'
import { properties } from './property'
import { users } from './user'
import { visits } from './visit'

export const maintenanceLogStepStatusEnum = pgEnum(
  'maintenance_log_step_status',
  ['completed', 'skipped', 'issue_found'],
)

export const maintenanceLogs = pgTable(
  'maintenance_logs',
  {
    ...getBaseFields(),
    propertyId: getIdReference(() => properties.id),
    visitId: getNullableIdReference(() => visits.id),
    maintenanceTaskId: getNullableIdReference(() => maintenanceTasks.id),
    taskNameSnapshot: text().notNull(),
    descriptionSnapshot: text(),
    completedDate: date(),
    completedByUserId: getNullableIdReference(() => users.id),
    notes: text(),
    actualCost: getMonetaryField(),
  },
  (table) => getBaseIndexes('maintenance_logs', table),
)

export const maintenanceLogSteps = pgTable(
  'maintenance_log_steps',
  {
    ...getBaseFields(),
    maintenanceLogId: getIdReference(() => maintenanceLogs.id),
    maintenanceTaskStepId: getNullableIdReference(
      () => maintenanceTaskSteps.id,
    ),
    stepNumberSnapshot: integer().notNull(),
    stepNameSnapshot: text().notNull(),
    descriptionSnapshot: text(),
    status: maintenanceLogStepStatusEnum().notNull().default('completed'),
    notes: text(),
  },
  (table) => getBaseIndexes('maintenance_log_steps', table),
)

export const maintenanceLogsRelations = relations(
  maintenanceLogs,
  ({ one, many }) => ({
    property: one(properties, {
      fields: [maintenanceLogs.propertyId],
      references: [properties.id],
    }),
    visit: one(visits, {
      fields: [maintenanceLogs.visitId],
      references: [visits.id],
    }),
    maintenanceTask: one(maintenanceTasks, {
      fields: [maintenanceLogs.maintenanceTaskId],
      references: [maintenanceTasks.id],
    }),
    completedByUser: one(users, {
      fields: [maintenanceLogs.completedByUserId],
      references: [users.id],
    }),
    steps: many(maintenanceLogSteps),
  }),
)

export const maintenanceLogStepsRelations = relations(
  maintenanceLogSteps,
  ({ one }) => ({
    maintenanceLog: one(maintenanceLogs, {
      fields: [maintenanceLogSteps.maintenanceLogId],
      references: [maintenanceLogs.id],
    }),
    maintenanceTaskStep: one(maintenanceTaskSteps, {
      fields: [maintenanceLogSteps.maintenanceTaskStepId],
      references: [maintenanceTaskSteps.id],
    }),
  }),
)
